import {AxiosResponse} from "axios";
import {$api} from "../api/api.ts";
import {getToken} from "../../utils/Utils.ts";
import {IPostResponseData} from "../models/PostResponse.ts";


export const PostService = {
    fetchPostData(id:string): Promise<AxiosResponse<IPostResponseData>> {
        return $api.get(`/post/${id}`, {
            headers: {
                Authorization: `Bearer tg-${getToken()}`
            }
        })
    },
}
